module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Contact Us","subtitle":"Write to us any question and we will answer you as soon as possible"},"ru":{"title":"Связаться с нами","subtitle":"Напишите нам любой интересующий вопрос, и мы ответим вам как можно скорее"}}')
  delete Component.options._Ctor
}
